import React, { useState, useEffect } from 'react'
// import { Autocomplete, useLoadScript } from "@react-google-maps/api";
// const placesLibrary = ["places"];
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { useSelector } from 'react-redux'
import SearchIcon from '@mui/icons-material/Search'
import AttractionsIcon from '@mui/icons-material/Attractions'
import Icon from '@mui/material/Icon'
import PublicIcon from '@mui/icons-material/Public'
import { Box, InputAdornment } from '@mui/material'
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListSubheader
} from '@mui/material'
import Image from 'next/image'

import { Skeleton } from '@mui/material'

const HotelDestination = ({
  setIsCityLoaded,
  setCityValue,
  cityValue,
  setSearchProduct,
  searchProduct,
  selectedValue,
  setSelectedValue,
  label,
  placeholder,
  setLoading,
  loading,
  autocompleteFirst,
  queryValue = '',
  error,
  helperText
}) => {
  const [value, setValue] = useState('')
  const { cityListRes } = useSelector(state => state.activity)
  const [cityList, setCityList] = useState([])

  const handleAutocompleteChange = (event, value) => {
    // Use the retrieved value as needed

    // const filterCode = city.filter((data) => value === data.cityName);
    setCityValue(value)
    // setValue(filterCode[0]?.countryName);
    //
  }

  /*  useEffect(() => {


    const lat = localStorage.getItem("latitude");
    const lng = localStorage.getItem("longitude");

    if (lat && lng) {
      dispatch(getCityList({ search: "", lat: lat, lng: lng }));
    }
  }, [dispatch]);

  useEffect(() => {
    if (cityListRes) {
      // setIsCityLoaded(false);
      setCityList(cityListRes.responseData);
    }
  }, [cityListRes]); */

  const flattenedOptions = cityValue.reduce((acc, curr) => {
    return [
      ...acc,
      ...curr.values.map(value => ({
        group: curr.label,
        img: curr.img,
        ...value
      }))
    ]
  }, [])

  const [isOnChange, setIsOnChange] = useState(true)

  // const flattenedOptions = cityValue?.reduce((acc, curr) => {
  //   return [
  //     ...acc,
  //     ...curr.values.map((value) => {
  //       const option = {
  //         group: curr.label,
  //         img: curr.img,
  //       };

  //       if (typeof value.name === "string") {
  //         option.name = value.name;
  //       } else if (typeof value.name === "object" && value.name.cityName) {
  //         option.name = value.name.cityName;
  //       }

  //       return option;
  //     }),
  //   ];
  // }, []);

  useEffect(() => {
    if (queryValue) {
      setIsOnChange(false)
    } else {
      if (isOnChange && flattenedOptions.length > 0) {
        setSelectedValue(flattenedOptions[0])
        setIsOnChange(false)
      }
    }
  }, [flattenedOptions, isOnChange])

  // Checck Push

  // useEffect(() => {
  //   if (flattenedOptions.length > 0) {
  //     setLoading(true)
  //     setTimeout(() => {
  //       setLoading(false)
  //     }, 2000)
  //   } else {
  //     setLoading(true)
  //     setTimeout(() => {
  //       setLoading(false)
  //     }, 2000)
  //   }

  // }, [flattenedOptions, searchProduct])

  return (
    <Box className={`searchMenu-loc lg:px-0 js-form-dd`}
      sx={{
        '& label.Mui-focused': {
          color: 'black'
        },

        '& .MuiListSubheader-root': {
          // height: "16px",
          backgroundColor: 'red'
        },
        '& .MuiInputBase-input': {
          // height: "16px",
        },
        '& .MuiAutocomplete-clearIndicator': {
          display: 'none' // Hides the clear (close) button
        },

        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: '1px solid rgba(0, 0, 0, 0.5)'
        },
        '& .MuiInput-underline:after': {
          border: '1px solid rgba(0, 0, 0, 0.5)'
        },
        '& .MuiAutocomplete-listbox': {
          overflow: 'hidden'
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            border: '1px solid rgba(0, 0, 0, 0.5)',
            borderRadius: '8px'
          },
          '&:hover fieldset': {
            border: '1px solid rgba(0, 0, 0, 0.5)'
          },
          '&.Mui-focused fieldset': {
            border: '1px solid rgba(0, 0, 0, 0.5)'
          }
        },
        '&::-webkit-scrollbar': {
          width: '2px'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#888',
          borderRadius: '6px'
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#555'
        }
      }}>
      <Autocomplete
        value={selectedValue}
        size='small'
        ref={autocompleteFirst}
        onChange={(event, newValue) => {
          setSelectedValue(newValue)
          setIsOnChange(false)
        }}
        filterOptions={x => x}
        onInputChange={(event, newInputValue) => {
          setSearchProduct(newInputValue)
          setIsOnChange(false)
        }}
        options={flattenedOptions}
        groupBy={option => option.group}
        getOptionLabel={option => option.name}
        renderInput={params => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position='start'>
                  <PublicIcon />
                </InputAdornment>
              ),
              style: error ? { borderColor: 'red' } : {}
            }}
            error={error}
            helperText={helperText}
          />
        )}
        renderOption={(props, option) => (
          <ListItem {...props}>
            <div
              style={{
                minWidth: '35px',
                textAlign: 'left'
              }}
            >
              <Image
                height='100'
                width='100'
                style={{
                  width: '20px',
                  height: '20px'
                }}
                alt={option.name}
                src={option.img}
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start'
              }}
            >
              <ListItemText
                primaryTypographyProps={{
                  sx: { fontSize: '14px' }
                }}
                primary={option.name}
                style={{ marginTop: 0, marginBottom: 0 }}
              />
              <ListItemText
                primaryTypographyProps={{
                  sx: { fontSize: '12px' }
                }}
                primary={option.countryName}
                style={{ marginTop: 0, marginBottom: 0 }}
              />
            </div>
          </ListItem>
        )}
        noOptionsText={
          loading || isOnChange ? (
            <Skeleton variant='text' sx={{ fontSize: '1rem' }} />
          ) : (
            <div
              style={{
                padding: '16px',
                textAlign: 'center',
                color: '#666',
                fontSize: '14px',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px'
              }}
            >
              <strong style={{ fontSize: '16px', color: '#333' }}>
                No results found for {searchProduct}
              </strong>
              <p style={{ marginTop: '5px' }}>
                Try searching with a different keyword.
              </p>
            </div>
          )
        }
      />
    </Box>
  )
}

export default HotelDestination
